import { controls, currencyToNumber, grouped } from "../../controls";

const pacs_financial_position_bank = {
  label: "PACS Financial Position",
  starting: true,
  url: "pacs_financial_position",
  pageLabel: "PACS Financial Position",
  pageType: "history",
  // filteraction: true,
  filter: [

    ...controls.displayText({ tab: "filter", label: "DCC Bank" }),
    ...controls.oc({ tab: "filter", length: 4, c: "Client", placeHolder: "Bank Code", name: "client_code", fastpath: "clients" }),
    ...controls.showData({ tab: "filter", displaytype: "capital", data: "client_display" }),

    ...controls.magicDateLabel({ tab: "filter", label: "As On Date", width: "col-sm-2", target: "as_on_date" }),
    ...controls.magicDate({ tab: "filter", name: "as_on_date", width: "col-sm-2", dateType: "ontype", default: "lfe" }),



  ],
  form: [],
  history: {
    perPage: 50,
    reportHeader: "Monthly Financial Position",
    filterable: true,
    sortable: true,
    defaultsTo: 0,
    pdfProps: { pageSize: "A3", pageOrientation: "landscape" },
    textReportProps: {
      'Recon': {
        filename: `Monthly Financial Position-$pageData.as_on_date$.txt`,
        format: {},
        separator: "|"
      },
    },
    pivot: true,
    charts: {
      pie: {
        row: { targetfield: 'pct_2021', flabel: 'pacs_name' },
        column: { targetrow: 'grand_total' },
        // colors:[...Array(100).keys()].map(r=>chroma.random())
      }
    },
    extraRows: {
      location: "bottom",
      fields: ["own_funds", "deposits", "accumulated_profits", "accumulated_losses", "profit_during_year", "loss_during_year", "total_members", "count_total_loanee", "amount_total_outstanding", "count_regular_loanee", "amount_regular_outstanding", "count_defaulter_loanee_2021", "amount_defaulter_outstanding_2021", "count_defaulter_loanee_2020", "amount_defaulter_outstanding_2020", "count_recovery_overdue_2020", "amount_recovery_overdue_2020", "count_recovery_overdue_2021", "amount_recovery_overdue_2021"],
      subtotals: {
        by: "client_display",
        displayIn: "pacs_name",
        count: true
      },
      grandtotal: { type: "fixed", displayIn: "pacs_name", val: "Grand Total", count: true },
    },

    displayColumns: [
      { Header: "Sr", accessor: "srno", type: "autoinc" },
      { Header: "Name", accessor: "pacs_name", rwidth: "*" },
      // { Header: "Count", accessor: "ct" },

      { Header: "Own Funds", accessor: "own_funds", type: "currency" },
      { Header: "Deposits", accessor: "deposits", type: "currency" },

      {
        Header: "Accumulated",
        columns: [
          { Header: "Profits", accessor: "accumulated_profits", type: "currency" },
          { Header: "Losses", accessor: "accumulated_losses", type: "currency" },
        ]
      },
      {
        Header: "During Year",
        columns: [{ Header: "Profits", accessor: "profit_during_year", type: "currency" },
        { Header: "Losses", accessor: "loss_during_year", type: "currency" }]
      },
      { Header: "Total Members", accessor: "total_members", align: "center" },

      {
        Header: "Total Outstanding",
        columns: [

          { Header: "Members", accessor: "count_total_loanee", align: "center" }
          ,
          { Header: "Amount", accessor: "amount_total_outstanding", type: "currency" },

        ]
      },
      {
        Header: "Regular",
        columns: [
          { Header: "Members", accessor: "count_regular_loanee", align: "center" },
          { Header: "Amount", accessor: "amount_regular_outstanding", type: "currency" },

        ]
      },
      {
        Header: "Defaulter Overdue 2021",
        columns: [
          { Header: "Members", accessor: "count_defaulter_loanee_2021", align: "center" },
          { Header: "Amount", accessor: "amount_defaulter_outstanding_2021", type: "currency" },

        ]
      },
      {
        Header: "Defaulter Overdue 2020",
        columns: [
          { Header: "Members", accessor: "count_defaulter_loanee_2020", align: "center" },
          { Header: "Amount", accessor: "amount_defaulter_outstanding_2020", type: "currency" },

        ]
      },
      {
        Header: "Overdue Recovery 2020",
        columns: [
          { Header: "Members", accessor: "count_recovery_overdue_2020", align: "center" },
          { Header: "Amount", accessor: "amount_recovery_overdue_2020", type: "currency" },
        ]
      },
      {
        Header: "Overdue Recovery 2021",
        columns: [
          { Header: "Members", accessor: "count_recovery_overdue_2021", align: "center" },
          { Header: "Amount", accessor: "amount_recovery_overdue_2021", type: "currency" }
        ]
      },

      {
        Header: "% Recovery to Overdue",
        columns: [
          {
            Header: "2020",
            accessor: "pct_2020",
            width132: { size: 13, },
            formula: [{
              f: 'simpleArithmatic', calcType: 'pct', inputs: [
                { source: 'row', field: 'amount_recovery_overdue_2020' },
                { source: 'row', field: 'amount_defaulter_outstanding_2020' },
              ], resultVar: 'total'
            }],
            align: "center"
          },
          {
            Header: "2021",
            accessor: "pct_2021",
            width132: { size: 13, },
            formula: [{
              f: 'simpleArithmatic', calcType: 'pct', inputs: [
                { source: 'row', field: 'amount_recovery_overdue_2021' },
                { source: 'row', field: 'amount_defaulter_outstanding_2021' },
              ], resultVar: 'total'
            }],
            align: "center"
          }
        ]
      }

    ]
  }
};

export default pacs_financial_position_bank;